const NORWEGIAN_TIMEZONE = 'Europe/Oslo'
const NORWEGIAN_LOCALE = 'nb-NO'

export function toNorwegianTime(timestamp: string): Date {
  if (!timestamp) {
    throw new Error('Invalid timestamp')
  }
  return new Date(timestamp)
}

export function formatTime(timestamp: string): string {
  if (!timestamp) {
    return '--:--'
  }
  try {
    if (timestamp.includes('T')) {
      const timePart = timestamp.split('T')[1]
      const [hours, minutes] = timePart.split(':').map(Number)
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    } else {
      const date = toNorwegianTime(timestamp)
      return new Intl.DateTimeFormat(NORWEGIAN_LOCALE, {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: NORWEGIAN_TIMEZONE
      }).format(date)
    }
  } catch (error) {
    console.error('Invalid date:', timestamp)
    return '--:--'
  }
}

export function formatDate(timestamp: string): string {
  try {
    const date = toNorwegianTime(timestamp)
    return new Intl.DateTimeFormat(NORWEGIAN_LOCALE, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: NORWEGIAN_TIMEZONE
    }).format(date)
  } catch (error) {
    console.error('Invalid date:', timestamp)
    return 'Invalid date'
  }
}

export function formatDuration(duration: string | undefined | null): string {
  if (!duration) return '--'
  
  const match = duration.match(/PT(\d+H)?(\d+M)?/)
  if (!match) return duration

  const hours = match[1] ? match[1].replace('H', '') : '0'
  const minutes = match[2] ? match[2].replace('M', '') : '0'

  return `${parseInt(hours)}t ${parseInt(minutes)}min`
}

export function formatCalendarDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
